export default async ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  Vue.prototype.sortByKey = (array, key) => array.sort(
    (a, b) => {
      const x = key(a)
      const y = key(b)

      if (x < y) {
        return -1
      }
      if (x > y) {
        return 1
      }
      return 0
    }
  )
  Vue.prototype.removeJibberish = (val) => {
    return Vue.prototype.sanitize$(val, { allowedTags: [], allowedAttributes: {} })
  }
}
